import React, { useState } from "react";

import "./Ausencias.css";

import AusenciasPorSedeYPromocion from "./AusenciasPorSedeYPromocion ";
import AusenciasSemanal from "./AusenciasSemanal";

import SancionesPorSedeYPromocion from "./SancionesPorSedeYPromocion";
import SancionesPorSedeYPromocionSemanal from "./SancionesPorSedeYPromocionSemanal";

import ParteList from "../Cuerpo/ParteList";
import CadetesReport from "./CadetesReport";

import InformePaseSalidaTotal from "./InformePaseSalidaTotal";
import InformeAusencias from "./InformeAusencias";
import InformeSanciones from "./InformesSanciones";

import comprueboPermisos from "../tools/comprueboPermisos";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";


const Ausencia = () => {
  const Usuario = ObtieneDatosCookies();

  const [veoInternos, setVeoInternos] = useState(false);

  const puedeVerInformesPases =
    comprueboPermisos(
      Usuario?.funcion,
      "Veo informe pases"
    );

  return (
    <div className="inf-v2-page">
      <div className="inf-v2-container">

        {/* =================================================== */}
        {/* CABECERA */}
        {/* =================================================== */}

        <section className="inf-v2-header">
          <div>
            <span className="inf-v2-eyebrow">
              INFORMES · GESTIÓN DE CADETES
            </span>

            <h1 className="inf-v2-title">
              Informes y Estadísticas
            </h1>

            <p className="inf-v2-subtitle">
              Panel consolidado de inasistencias,
              sanciones, partes y movimientos de
              cadetes.
            </p>
          </div>

          <div className="inf-v2-header-badge">
            ISeP
          </div>
        </section>

        {/* =================================================== */}
        {/* INFORMES GENERALES */}
        {/* =================================================== */}

        {puedeVerInformesPases && (
          <section className="inf-v2-section">
            <div className="inf-v2-section-header">

              <div className="inf-v2-section-title-group">
                <div className="inf-v2-indicator inf-v2-indicator-main" />

                <div>
                  <h2>
                    Informes Generales
                  </h2>

                  <p>
                    Consultas consolidadas de
                    movimientos, ausencias y
                    sanciones.
                  </p>
                </div>
              </div>

              <span className="inf-v2-badge">
                Consultas
              </span>

            </div>

            <div className="inf-v2-general-grid">

              {/* ============================================= */}
              {/* PASES */}
              {/* ============================================= */}

              <div className="inf-v2-general-card">
                <div className="inf-v2-general-card-title">
                  <div className="inf-v2-general-icon">
                    ↗
                  </div>

                  <div>
                    <strong>
                      Pases de Salida
                    </strong>

                    <span>
                      Informe histórico y general
                    </span>
                  </div>
                </div>

                <div className="inf-v2-general-content">
                  <InformePaseSalidaTotal />
                </div>
              </div>

              {/* ============================================= */}
              {/* AUSENCIAS */}
              {/* ============================================= */}

              <div className="inf-v2-general-card">
                <div className="inf-v2-general-card-title">

                  <div className="inf-v2-general-icon inf-v2-general-icon-warning">
                    !
                  </div>

                  <div>
                    <strong>
                      Ausencias
                    </strong>

                    <span>
                      Consulta e informe de inasistencias
                    </span>
                  </div>
                </div>

                <div className="inf-v2-general-content">
                  <InformeAusencias />
                </div>
              </div>

              {/* ============================================= */}
              {/* SANCIONES */}
              {/* ============================================= */}

              <div className="inf-v2-general-card">

                <div className="inf-v2-general-card-title">

                  <div className="inf-v2-general-icon inf-v2-general-icon-danger">
                    ⚖
                  </div>

                  <div>
                    <strong>
                      Sanciones
                    </strong>

                    <span>
                      Informe disciplinario
                    </span>
                  </div>
                </div>

                <div className="inf-v2-general-content">
                  <InformeSanciones />
                </div>

              </div>

            </div>
          </section>
        )}

        {/* =================================================== */}
        {/* ESTADISTICAS */}
        {/* =================================================== */}

        <section className="inf-v2-section">

          <div className="inf-v2-section-header">

            <div className="inf-v2-section-title-group">
              <div className="inf-v2-indicator inf-v2-indicator-stats" />

              <div>
                <h2>
                  Indicadores de Gestión
                </h2>

                <p>
                  Distribución histórica y semanal
                  por sede y promoción.
                </p>
              </div>
            </div>

            <span className="inf-v2-badge inf-v2-badge-blue">
              Estadísticas
            </span>

          </div>

          <div className="inf-v2-dashboard-grid">

            {/* =============================================== */}
            {/* INASISTENCIAS TOTALES */}
            {/* =============================================== */}

            <article className="inf-v2-dashboard-card">

              <div className="inf-v2-dashboard-header">

                <div className="inf-v2-dashboard-icon inf-v2-icon-grey">
                  ∑
                </div>

                <div>
                  <span className="inf-v2-dashboard-label">
                    INASISTENCIAS
                  </span>

                  <h3>
                    Totales
                  </h3>

                  <p>
                    Acumulado por sede y promoción.
                  </p>
                </div>

              </div>

              <div className="inf-v2-dashboard-content">
                <AusenciasPorSedeYPromocion />
              </div>

            </article>

            {/* =============================================== */}
            {/* INASISTENCIAS SEMANALES */}
            {/* =============================================== */}

            <article className="inf-v2-dashboard-card">

              <div className="inf-v2-dashboard-header">

                <div className="inf-v2-dashboard-icon inf-v2-icon-warning">
                  7d
                </div>

                <div>
                  <span className="inf-v2-dashboard-label">
                    INASISTENCIAS
                  </span>

                  <h3>
                    Semanales
                  </h3>

                  <p>
                    Comportamiento de los últimos días.
                  </p>
                </div>

              </div>

              <div className="inf-v2-dashboard-content">
                <AusenciasSemanal />
              </div>

            </article>

            {/* =============================================== */}
            {/* SANCIONES TOTALES */}
            {/* =============================================== */}

            <article className="inf-v2-dashboard-card">

              <div className="inf-v2-dashboard-header">

                <div className="inf-v2-dashboard-icon inf-v2-icon-purple">
                  ⚖
                </div>

                <div>
                  <span className="inf-v2-dashboard-label">
                    SANCIONES
                  </span>

                  <h3>
                    Totales
                  </h3>

                  <p>
                    Acumulado disciplinario por sede.
                  </p>
                </div>

              </div>

              <div className="inf-v2-dashboard-content">
                <SancionesPorSedeYPromocion />
              </div>

            </article>

            {/* =============================================== */}
            {/* SANCIONES SEMANALES */}
            {/* =============================================== */}

            <article className="inf-v2-dashboard-card">

              <div className="inf-v2-dashboard-header">

                <div className="inf-v2-dashboard-icon inf-v2-icon-success">
                  7d
                </div>

                <div>
                  <span className="inf-v2-dashboard-label">
                    SANCIONES
                  </span>

                  <h3>
                    Semanales
                  </h3>

                  <p>
                    Evolución disciplinaria reciente.
                  </p>
                </div>

              </div>

              <div className="inf-v2-dashboard-content">
                <SancionesPorSedeYPromocionSemanal />
              </div>

            </article>

          </div>
        </section>

        {/* =================================================== */}
        {/* PARTE */}
        {/* =================================================== */}

        <section className="inf-v2-section">

          <div className="inf-v2-section-header">

            <div className="inf-v2-section-title-group">

              <div className="inf-v2-indicator inf-v2-indicator-partes" />

              <div>
                <h2>
                  Partes
                </h2>

                <p>
                  Información consolidada del
                  parte de cadetes.
                </p>
              </div>

            </div>

            <span className="inf-v2-badge inf-v2-badge-green">
              Operativo
            </span>

          </div>

          <div className="inf-v2-section-content">
            <ParteList />
          </div>

        </section>

        {/* =================================================== */}
        {/* REPORTE 30 DIAS */}
        {/* =================================================== */}

        <section
          className={`inf-v2-section inf-v2-report-section ${
            veoInternos
              ? "inf-v2-report-open"
              : ""
          }`}
        >

          <button
            type="button"
            className="inf-v2-report-trigger"
            onClick={() =>
              setVeoInternos((prev) => !prev)
            }
          >

            <div className="inf-v2-report-trigger-left">

              <div className="inf-v2-report-icon">
                📊
              </div>

              <div>
                <span className="inf-v2-report-eyebrow">
                  ANÁLISIS HISTÓRICO
                </span>

                <strong>
                  Reporte de Cadetes
                </strong>

                <small>
                  Actividad registrada durante los
                  últimos 30 días
                </small>
              </div>

            </div>

            <div className="inf-v2-report-trigger-right">

              <span
                className={`inf-v2-chevron ${
                  veoInternos
                    ? "inf-v2-chevron-open"
                    : ""
                }`}
              >
                ▼
              </span>

            </div>

          </button>

          {veoInternos && (
            <div className="inf-v2-report-content">
              <CadetesReport />
            </div>
          )}

        </section>

      </div>
    </div>
  );
};

export default Ausencia;